// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__Rqp5O","active":"Menu_active__ntKqi"};